import { render, staticRenderFns } from "./HomePress.vue?vue&type=template&id=00c3204a&lang=pug&"
import script from "./HomePress.vue?vue&type=script&lang=js&"
export * from "./HomePress.vue?vue&type=script&lang=js&"
import style0 from "./HomePress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports